import React from "react"
import { useParams } from "react-router-dom"

import { Loader, LoaderSize, Text } from "@izettle/react"
import { useLocalization } from "@izettle/tenko-react"

import { Page } from "@/core/components/shared"
import { useMemberMerchantDetails } from "@/modules/members/api/use-merchant-details"
import { Container, Content } from "@/modules/members/pages/styles"

export default function MembersPolicyPage() {
  const { text } = useLocalization()

  const { memberUuid } = useParams<{
    memberUuid: string
  }>()

  const { data, isFetching } = useMemberMerchantDetails(memberUuid ?? "")

  if (isFetching) {
    return (
      <Page data-testid="loading">
        <Loader size={LoaderSize.Large} />
      </Page>
    )
  }

  return (
    <Page>
      <Container>
        <Content>
          <Text.Regular>
            {text("MEMBERS_INTEGRITY_POLICY", [data?.legalName])}
          </Text.Regular>
        </Content>
      </Container>
    </Page>
  )
}
